import React from 'react';
import './Footer.css';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';

function Footer() {
  return (
    <footer>
      <p><a href="/">© 2026 Klara Krämer - All Rights Reserved</a></p>
      {/* <a
        href="https://www.linkedin.com/in/klara-krämer/"
        target="_blank"
        rel="noopener noreferrer"
        className="linkedin-icon"
      >
        <FontAwesomeIcon icon={faLinkedinIn} style={{color: "#ffffff",}} />
      </a> */}
    </footer>
  );
}

export default Footer;